import { Params } from '@angular/router';
import { CategoryFilter } from '~app/modules/filters/models';
import { FilterHandlerParams } from '~app/modules/filters/models/filter-handler-params';

export class CategoriesFilterHandler {

  private static _instance: CategoriesFilterHandler;
  public static get instance(): CategoriesFilterHandler {
    if (!CategoriesFilterHandler._instance) {
      CategoriesFilterHandler._instance = new CategoriesFilterHandler();
    }

    return CategoriesFilterHandler._instance;
  }

  protected queryParams: Params;

  protected constructor() {
  }

  updateQueryParams(params: Params): void {
    this.queryParams = params;
  }

  apply(categoriesSlugs: CategoryFilter[]): FilterHandlerParams {
    const { filter: { options = {}, categories = {}, categoryIds = {}, ...rest } = {} } = this.queryParams || {};
    return {
      params: {
        filter: {
          categories: Object.assign({},  categoriesSlugs.map(a => a.slug)),
          categoryIds: Object.assign({},  categoriesSlugs.map(a => a.id)),
          options,
          ...rest
        }
      }
    };
  }

  remove(category: string, id: string): FilterHandlerParams {
    const { filter: { categories, categoryIds } } = this.queryParams || {};
    const filteredCategories = categories
      .filter((m: string) => m !== category);
    const filteredCategoriesId = categoryIds
      .filter((m: string) => m !== id);

    return this.apply([
        ...filteredCategories.map((item, idx) => ({ 'slug': item, 'id': filteredCategoriesId[idx]}))
    ]);
  }

  reset(): FilterHandlerParams {
    return this.apply([]);
  }
}
